import { render, staticRenderFns } from "./activitiesTypeManageList.vue?vue&type=template&id=bf5bfe68&scoped=true"
import script from "./activitiesTypeManageList.vue?vue&type=script&lang=js"
export * from "./activitiesTypeManageList.vue?vue&type=script&lang=js"
import style0 from "./activitiesTypeManageList.vue?vue&type=style&index=0&id=bf5bfe68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5bfe68",
  null
  
)

export default component.exports